<template>
  <div class="product">
    <banner img="../assets/img/website_image/bgtop.jpg" title="产品功能" />
    <div class="product-content">
      <!-- 智能推荐 -->
      <div class="target">
        <h3 class="title">本地菜农直供</h3>
        <div class="target-img">
          <img src="../assets/img/website_image/tuijian.jpg" alt />
        </div>
      </div>
      <!--随机匹配  -->
      <div class="target">
        <h3 class="title">物美价廉</h3>
        <div class="target-img">
          <img src="../assets/img/website_image/match.jpg" alt />
        </div>
      </div>
      <!--动态圈  -->
      <div class="target">
        <h3 class="title">极速配送</h3>
        <div class="target-img">
          <img src="../assets/img/website_image/moment.jpg" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}

//平台目标
.target {
  margin-top: 50px;
  &-img {
    margin-top: 50px;
    text-align: center;
  }
}

//
.modular {
  margin-top: 50px;
  .modular-content {
    padding: 50px 50px;
    display: flex;
    justify-content: space-around;
  }
}
.modular-content-same {
  width: 182px;
  height: 405px;

  .same-item {
    height: 70px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .same-item-img {
      width: 70px;
      height: 70px;
      line-height: 100px;
      background: #1667a0;
      border-radius: 50%;
      text-align: center;
    }
    p {
      color: #1667a0;
      font-weight: 700;
      line-height: 70px;
    }
  }
}

.modular-content-center {
  width: 355px;
  height: 355px;
  img {
    width: 100%;
  }
}
//公共样式
.title,
.eTitle {
  font-size: 34px;
  font-weight: 400;
  color: #333;
  text-align: center;
}
.eTitle {
  font-size: 20px;
  padding: 10px 0;
}
</style>